import {DomainObject} from 'shared/store';
import {observable, computed} from 'mobx';

class ForecastedAccountBalance extends DomainObject {
  @observable used;
  @observable available;
  @observable scheduled;
  @observable workDayLength;
  @observable unlimited;
  @observable typeUnit;

  @computed get usedDaysOrHours() {
    return Math.round(this.used * 100 / this.secondsPerUnit) / 100;
  }

  @computed get scheduledDaysOrHours() {
    return Math.round(this.scheduled * 100 / this.secondsPerUnit) / 100;
  }

  @computed get availableDaysOrHours() {
    return Math.round(this.available * 100 / this.secondsPerUnit) / 100;
  }

  @computed get secondsPerUnit() {
    if (this.typeUnit === 'days') {
      return this.workDayLength;
    } else if (this.typeUnit === 'hours') {
      return 3600;
    } else {
      throw new Error(`Unrecognized type unit ${this.typeUnit} in forecasted balance`);
    }
  }
}

export default ForecastedAccountBalance;
